import { isObject } from '@/utils/tools';

function replaceLeftMenuSettings(state, payload) {
  if (isObject(payload, true)) {
    // FIXME: validate incoming data:
    // the settings become invalid
    // if the REST Endpoint returns
    // {"open":{"type":null,"delay":null},"close":{"delay":null,"type":null}}
    state.settings = payload;
  }
}

function replaceLeftMenuItems(state, payload) {
  if (Array.isArray(payload)) {
    state.items = payload;
  }
}

export default {
  replaceLeftMenuItems,
  replaceLeftMenuSettings,
};
